<script lang="ts">
    export let type: 'blogs' | 'news' = 'news';
    export let itemsPerPage = 5;
</script>

{#if type === 'news'}
    <!-- Newsletter Skeletons -->
    <div class="flex flex-col gap-4 animate-pulse" data-testid="newsletter-skeleton-loader">
        <!-- Archive Year Dropdown Skeleton -->
        <div class="flex gap-4 items-center mb-3">
            <div class="h-4 bg-gray-300 w-20 rounded"></div>
            <div class="h-10 w-20 bg-gray-200 rounded-lg shadow-sm"></div>
        </div>

        <!-- Newsletter Cards -->
        <ul class="flex flex-col gap-5 p-0 list-none">
            {#each Array(itemsPerPage).fill(0) as _, index}
                <li class="block transition-transform duration-200 ease-in-out hover:scale-105">
                    <div class="flex flex-col md:flex-row border border-gray-300 bg-white overflow-hidden h-auto md:h-[150px] rounded-lg">
                        <div class="w-full md:w-2/5 h-[140px] md:h-full bg-gray-300"></div>
                        <div class="w-full md:w-3/5 p-4 md:p-6 flex flex-col gap-2">
                            <div class="h-3 bg-gray-300 w-20 rounded"></div>
                            <div class="h-5 bg-gray-300 w-4/5 rounded mt-3"></div>
                        </div>
                    </div>
                </li>
            {/each}
        </ul>
    </div>

{:else if type === 'blogs'}
    <!-- Blog Skeletons -->
    <ul class="flex flex-col gap-6 p-0 list-none animate-pulse" data-testid="skeleton-loader">
        {#each Array(itemsPerPage).fill(0) as _, index}
            <li class="block transition-transform duration-200 ease-in-out hover:scale-105">
                <div class="flex flex-col md:flex-row border border-gray-300 bg-white overflow-hidden h-auto md:h-[280px] rounded-lg">
                    <!-- Image skeleton (matches blog card 2/5 column) -->
                    <div class="w-full md:w-2/5 h-[160px] md:h-full bg-gray-300"></div>

                    <!-- Content skeleton -->
                    <div class="w-full md:w-3/5 p-4 md:p-6 flex flex-col gap-2 mt-3 md:mt-0">
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-300 flex-shrink-0"></div>
                            <div class="flex flex-col gap-0.5 justify-center min-w-0 py-0.5">
                                <div class="h-4 bg-gray-300 w-24 rounded"></div>
                                <div class="h-3 bg-gray-200 w-16 rounded"></div>
                            </div>
                        </div>
                        <div class="h-5 bg-gray-300 w-3/4 rounded mt-3"></div>
                        <div class="space-y-2 mt-3">
                            <div class="h-3 bg-gray-200 w-full rounded"></div>
                            <div class="h-3 bg-gray-200 w-5/6 rounded"></div>
                            <div class="h-3 bg-gray-200 w-full rounded"></div>
                            <div class="h-3 bg-gray-200 w-5/6 rounded"></div>
                            <div class="h-3 bg-gray-200 w-4/6 rounded"></div>
                        </div>
                    </div>
                </div>
            </li>
        {/each}
    </ul>
{/if}
